import { ActionBannerCenter as ActionBannerCenter$1 } from '@cbhq/cdx-components';
import { mapEntryLink } from '../globals/navlink.js';
import { CONTENTFUL_COMPONENTS_STYLE_MAP } from './contentToPropsMap.js';
import { jsx } from 'react/jsx-runtime';
const ACTION_BANNER_CENTER_CONTENT_MODEL_ID = 'cdxActionBannerCenter';
function ActionBannerCenter({
  headline,
  subhead,
  media,
  link,
  style = 'Default',
  anchor,
  hasSpacingTop = true
}) {
  const navLink = link && mapEntryLink(link);
  const styleValue = CONTENTFUL_COMPONENTS_STYLE_MAP[style];
  return /*#__PURE__*/jsx(ActionBannerCenter$1, {
    headline: headline,
    subhead: subhead,
    ctaButtonLabel: navLink?.label,
    ctaButtonUrl: navLink?.url,
    mediaAlt: media?.fields?.altText,
    mediaUrl: media?.fields?.media?.fields?.file?.url,
    hasSpacingTop: hasSpacingTop,
    style: styleValue,
    anchor: anchor
  });
}
export { ACTION_BANNER_CENTER_CONTENT_MODEL_ID, ActionBannerCenter };
//# sourceMappingURL=ActionBannerCenter.js.map
